import { Box, FormControlLabel, Switch, TextField } from '@material-ui/core';
import React from 'react';
import { IScheduleDetails } from 'src/redux/Calendar/interfaces';
import { useStyles } from './styles';

interface IScheduleMaster
  extends Omit<IScheduleDetails, 'calendar_id' | 'sold'> {
  disable_sell_change: 0 | 1;
}

export const SchedulesBulkForm = ({
  state,
  setState,
}: {
  state: IScheduleMaster;
  setState: React.Dispatch<React.SetStateAction<IScheduleMaster>>;
}) => {
  const classes = useStyles();
  const changeState = (data: Partial<IScheduleMaster>) => {
    setState((prev) => ({ ...prev, ...data }));
  };

  const toggleFields = () => {
    setState((prev) => ({
      ...prev,
      disable_sell_change: prev.disable_sell_change ? 0 : 1,
      is_disabled: '0',
    }));
  };

  if (!state) return null;

  return (
    <Box>
      <Box
        display="flex"
        pb={2}
        pt={3}
        justifyContent="center"
        flexWrap="wrap"
        gridGap="10px">
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            value={state.min_tickets || ''}
            onChange={(e) => changeState({ min_tickets: e.target.value })}
            variant="outlined"
            InputProps={{
              style: {
                background: '#fff',
                borderRadius: '4px',
                width: '120px',
              },
            }}
            inputProps={{
              min: 0,
              step: 1,
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Min Tickets"
          />
        </Box>
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            value={state.max_tickets || ''}
            onChange={(e) => changeState({ max_tickets: e.target.value })}
            variant="outlined"
            InputProps={{
              style: {
                background: '#fff',
                borderRadius: '4px',
                width: '120px',
              },
            }}
            inputProps={{
              min: 0,
              step: 1,
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Max Tickets"
          />
        </Box>
        <Box display="flex">
          <Box
            display="flex"
            alignItems="center"
            mr={4}
            ml={6}
            position="relative">
            <FormControlLabel
              control={<Switch className={classes.customSwitch} />}
              label="Disable"
              checked={Boolean(state.is_disabled && +state.is_disabled)}
              onChange={(_, checked) =>
                changeState({ is_disabled: checked ? '1' : '0' })
              }
              disabled={!!state.disable_sell_change}
            />
            <Box
              style={{
                position: 'absolute',
                cursor: 'pointer',
                opacity: '0.7',
                bottom: '-20px',
                left: 0,
                display: 'inline-block',
                textDecoration: 'underline',
              }}
              onClick={() => toggleFields()}>
              {!!state.disable_sell_change ? 'Make changes' : "Don't change"}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
